import React, { useEffect, useRef, useState } from "react";
import "../../css_files/Enquiry/ServiceEnquiry.css";
import { toast } from "react-toastify";
import CloseForm from "../Master/CloseForm";
import axiosInstance from "../../api";
import Swal from "sweetalert2";
import LoadingScreen from "../Homepage/LoadingScreen";
import Select from "react-select";

function ServiceEnquiry({
  setShowServiceEnquiry,
  setrefresh,
  refresh,
  customerData,
  companyData,
  getcustomer,
  getaddress,
  addressData,
  showServiceEnquiry,
  triggerEnquiry,
  customerBoilerData,
  getboiler,
  setRotateReload,
  rotateReload,
  enquiryType,
}) {
  const initialState = {
    CompanyId: "",
    EnquiryType: showServiceEnquiry && enquiryType,
    ServicesLookingFor: "",
    DateOfEnquiry: getDateofEnquiry(new Date()),
    Priority: "",
    IsTicketCreated: false,

    CustomerId: "",
    BillToAddressId: "",
    ShipToAddressId: "",
    CustomerBoilerId: "",
  };
  const [serviceEnquiryForm, setServiceEnquiryForm] = useState(initialState);

  useEffect(() => {
    if (triggerEnquiry.update) {
      axiosInstance
        .get(
          `${
            process.env.REACT_APP_API_URL
          }/api/v1/NewEnquiry/GetEnquiryById?seriesId=${encodeURIComponent(
            triggerEnquiry.seriesId
          )}`
        )
        .then((res) => {
          setServiceEnquiryForm({
            CompanyId: res.data.companyId,
            EnquiryType: res.data.enquiryType,
            ServicesLookingFor: res.data.servicesLookingFor,
            DateOfEnquiry: getDateofEnquiry(new Date(res.data.dateOfEnquiry)),
            Priority: res.data.priority,
            IsTicketCreated: res.data.isTicketCreated,
            CustomerId: res.data.customerId,
            BillToAddressId: res.data.billToAddressId,
            ShipToAddressId: res.data.shipToAddressId,
            CustomerBoilerId: res.data.customerBoilerId,
          });
          getcustomer(res.data.companyId);
          getaddress(res.data.companyId);
          getboiler(res.data.companyId);
        })
        .catch(console.log);
    } else {
      getcustomer("");
      getaddress("");
      getboiler("");
    }
  }, [triggerEnquiry.update, triggerEnquiry.seriesId]);

  function getDateofEnquiry(date) {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");
    return `${year}-${month}-${day}`;
  }

  const [loading, setloading] = useState(false);

  function handleSubmit(e) {
    e.preventDefault();
    setloading(true);
    if (triggerEnquiry.update) {
      axiosInstance
        .put(`${process.env.REACT_APP_API_URL}/api/v1/NewEnquiry`, {
          ...serviceEnquiryForm,
          SeriesId: triggerEnquiry.seriesId,
          IsAddressSame:
            serviceEnquiryForm.BillToAddressId ==
            serviceEnquiryForm.ShipToAddressId,
        })
        .then((res) => {
          toast.success(res.data, {
            position: "bottom-center",
            theme: "dark",
          });
          setShowServiceEnquiry(false);
          setrefresh(!refresh);
          setloading(false);
        })
        .catch((err) => {
          console.log(err);
          setloading(false);
        });
    } else {
      axiosInstance
        .post(`${process.env.REACT_APP_API_URL}/api/v1/NewEnquiry`, {
          ...serviceEnquiryForm,
          IsAddressSame:
            serviceEnquiryForm.BillToAddressId ==
            serviceEnquiryForm.ShipToAddressId,
        })
        .then((res) => {
          toast.success(res.data.id, {
            position: "bottom-center",
            theme: "dark",
          });
          setShowServiceEnquiry(false);
          setrefresh(!refresh);
          setloading(false);
        })
        .catch((err) => {
          console.log(err);
          setloading(false);
        });
    }
  }

  return (
    <section className="service-enquiry">
      <form onSubmit={handleSubmit}>
        <blockquote
          style={{ flexDirection: "row", alignItems: "center", gap: "2rem" }}
        >
          <img src="/images/Image 905.jpg" height={100} />
          <h1>New {enquiryType} Enquiry</h1>
        </blockquote>

        <blockquote>
          <label>
            Company/Organization Name{" "}
            <sup>
              <i class="fa-solid fa-asterisk" style={{ color: "red" }}></i>
            </sup>
          </label>

          <aside>
            <Select
              isSearchable
              options={companyData}
              onChange={(values) => {
                const val = values?.value;

                setServiceEnquiryForm({
                  ...initialState,
                  CompanyId: val,
                });
                getcustomer(val);
                getaddress(val);
                getboiler(val);
              }}
              value={companyData?.find(
                (x) => x?.value === serviceEnquiryForm.CompanyId
              )}
              isClearable
              required
              placeholder="Select Company/Organization Name"
              styles={{
                container: (base) => ({
                  ...base,
                  width: "100%",
                }),
                placeholder: (base) => ({
                  ...base,
                  color: "black",
                }),
                control: (base, state) => ({
                  ...base,
                  borderColor: "black",
                  "&:hover": {
                    borderColor: "black",
                  },
                  boxShadow: "none",
                }),
                singleValue: (base) => ({
                  ...base,
                  color: "black",
                }),
                dropdownIndicator: (base) => ({
                  ...base,
                  color: "black",
                  "&:hover": {
                    color: "black",
                  },
                }),
                indicatorSeparator: (base) => ({
                  ...base,
                  backgroundColor: "black",
                }),
                noOptionsMessage: (base) => ({
                  ...base,
                  color: "black",
                }),
              }}
            />
            <i
              class={`fa-solid fa-rotate-right ${
                rotateReload.rotateCompanyName && "fa-spin"
              }`}
              title="refresh dropdown"
              onClick={() =>
                setRotateReload({
                  ...rotateReload,
                  reloadCompanyName: !rotateReload.reloadCompanyName,
                })
              }
            ></i>
          </aside>
        </blockquote>
        <blockquote>
          <label>
            Customer{" "}
            <sup>
              <i class="fa-solid fa-asterisk" style={{ color: "red" }}></i>
            </sup>
          </label>
          <aside>
            <select
              onChange={(e) => {
                setServiceEnquiryForm({
                  ...serviceEnquiryForm,
                  CustomerId: e.target.value,
                });
              }}
              required
            >
              <option value="">Select Customer</option>
              {customerData.map((customer) => (
                <option
                  value={customer.id}
                  selected={customer.id === serviceEnquiryForm.CustomerId}
                >
                  {customer.salutation} {customer.name} | {customer.email} |{" "}
                  {customer.phoneNumber}
                </option>
              ))}
            </select>
            <i
              class={`fa-solid fa-rotate-right ${
                rotateReload.rotateCustomerName && "fa-spin"
              }`}
              title="refresh dropdown"
              onClick={() => getcustomer(serviceEnquiryForm.CompanyId)}
            ></i>
          </aside>
        </blockquote>

        <blockquote>
          <label>
            Ship To Address{" "}
            <sup>
              <i class="fa-solid fa-asterisk" style={{ color: "red" }}></i>
            </sup>
          </label>
          <aside>
            <select
              onChange={(e) => {
                setServiceEnquiryForm({
                  ...serviceEnquiryForm,
                  ShipToAddressId: e.target.value,
                });
              }}
              required
            >
              <option value="">Select Address</option>
              {addressData.map((address) => (
                <option
                  value={address.id}
                  selected={address.id === serviceEnquiryForm.ShipToAddressId}
                >
                  {address.addressType} -{" "}
                  {address.officeName || address.factoryName},{" "}
                  {address.address1}, {address.address2},{" "}
                  {address?.cityObj?.name || address?.cityName},{" "}
                  {address?.stateObj?.name || address?.stateName},{" "}
                  {address.country}, {address.pincode}
                </option>
              ))}
            </select>
            <i
              class={`fa-solid fa-rotate-right ${
                rotateReload.rotateCustomerAddress && "fa-spin"
              }`}
              title="refresh dropdown"
              onClick={() => getaddress(serviceEnquiryForm.CompanyId)}
            ></i>
          </aside>
        </blockquote>
        <blockquote style={{ flexDirection: "row", alignItems: "center" }}>
          <input
            type="checkbox"
            checked={
              serviceEnquiryForm.BillToAddressId
                ? serviceEnquiryForm.BillToAddressId ==
                  serviceEnquiryForm.ShipToAddressId
                : false
            }
            onChange={(e) => {
              setServiceEnquiryForm({
                ...serviceEnquiryForm,
                BillToAddressId: e.target.checked
                  ? serviceEnquiryForm.ShipToAddressId
                  : "",
              });
            }}
          />
          <label>Is Bill To Address Is Same As Ship To Address ?</label>
        </blockquote>
        {(serviceEnquiryForm.BillToAddressId != "" &&
          serviceEnquiryForm.BillToAddressId ==
            serviceEnquiryForm.ShipToAddressId) === false && (
          <blockquote>
            <label>
              Bill To Address{" "}
              <sup>
                <i class="fa-solid fa-asterisk" style={{ color: "red" }}></i>
              </sup>
            </label>
            <aside>
              <select
                onChange={(e) => {
                  setServiceEnquiryForm({
                    ...serviceEnquiryForm,
                    BillToAddressId: e.target.value,
                  });
                }}
                required
              >
                <option value="">Select Address</option>
                {addressData.map((address) => (
                  <option
                    value={address.id}
                    selected={address.id === serviceEnquiryForm.BillToAddressId}
                  >
                    {address.addressType} -{" "}
                    {address.officeName || address.factoryName},{" "}
                    {address.address1}, {address.address2},
                    {address?.cityObj?.name || address?.cityName},{" "}
                    {address?.stateObj?.name || address?.stateName},
                    {address.country}, {address.pincode}
                  </option>
                ))}
              </select>
              <i
                class={`fa-solid fa-rotate-right ${
                  rotateReload.rotateCustomerAddress && "fa-spin"
                }`}
                title="refresh dropdown"
                onClick={() => getaddress(serviceEnquiryForm.CompanyId)}
              ></i>
            </aside>
          </blockquote>
        )}
        <blockquote>
          <label>
            Customer Boiler and Series{" "}
            <sup>
              <i class="fa-solid fa-asterisk" style={{ color: "red" }}></i>
            </sup>
          </label>
          <aside>
            <select
              onChange={(e) => {
                setServiceEnquiryForm({
                  ...serviceEnquiryForm,
                  CustomerBoilerId: e.target.value,
                });
              }}
              required
            >
              <option value="">Select Customer Boiler and Series</option>
              {customerBoilerData.map((boiler) => (
                <option
                  value={boiler.id}
                  selected={boiler.id === serviceEnquiryForm.CustomerBoilerId}
                >{`${boiler.boiler.head} | ${boiler.boilerSeriess.seriesCode}`}</option>
              ))}
            </select>
            <i
              class={`fa-solid fa-rotate-right ${
                rotateReload.rotateCustomerBoilerName && "fa-spin"
              }`}
              title="refresh dropdown"
              onClick={() => getboiler(serviceEnquiryForm.CompanyId)}
            ></i>
          </aside>
        </blockquote>

        <aside>
          <blockquote>
            <label>
              Date of Enquiry{" "}
              <sup>
                <i class="fa-solid fa-asterisk" style={{ color: "red" }}></i>
              </sup>
            </label>
            <input
              type="date"
              onChange={(e) => {
                setServiceEnquiryForm({
                  ...serviceEnquiryForm,
                  DateOfEnquiry: e.target.value,
                });
              }}
              value={serviceEnquiryForm.DateOfEnquiry}
              required
            />
          </blockquote>
          <blockquote>
            <label>
              Priority{" "}
              <sup>
                <i class="fa-solid fa-asterisk" style={{ color: "red" }}></i>
              </sup>
            </label>
            <select
              onChange={(e) => {
                setServiceEnquiryForm({
                  ...serviceEnquiryForm,
                  Priority: e.target.value,
                });
              }}
              required
            >
              <option value="">Select Priority</option>
              <option
                value="Low"
                selected={serviceEnquiryForm.Priority === "Low"}
              >
                Low
              </option>
              <option
                value="Medium"
                selected={serviceEnquiryForm.Priority === "Medium"}
              >
                Medium
              </option>
              <option
                value="High"
                selected={serviceEnquiryForm.Priority === "High"}
              >
                High
              </option>
            </select>
          </blockquote>
        </aside>
        <blockquote>
          <label>
            {enquiryType === "Service" ? "Services" : enquiryType} Looking For{" "}
            <sup>
              <i class="fa-solid fa-asterisk" style={{ color: "red" }}></i>
            </sup>
          </label>
          <textarea
            placeholder={`Enter ${
              enquiryType === "Service" ? "Services" : enquiryType
            } Looking For. Maximum 800 Characters`}
            rows={5}
            onInput={(e) => {
              e.target.value = e.target.value.slice(0, 800);
            }}
            onChange={(e) => {
              setServiceEnquiryForm({
                ...serviceEnquiryForm,
                ServicesLookingFor: e.target.value,
              });
            }}
            value={serviceEnquiryForm.ServicesLookingFor}
            required
          ></textarea>
        </blockquote>
        <CloseForm close={setShowServiceEnquiry} />

        <aside>
          <button
            type="button"
            onClick={() => {
              Swal.fire({
                icon: "warning",
                title: "Are You Sure?",
                text: "Form Data Will Get Reset",
                showConfirmButton: true,
                showCancelButton: true,
              }).then((x) => {
                if (x.isConfirmed) {
                  setServiceEnquiryForm(initialState);
                }
              });
            }}
          >
            Reset
          </button>
          <button type="submit">
            {triggerEnquiry.update ? "Update Enquiry" : "Create Enquiry"}
          </button>
        </aside>
        {loading && <LoadingScreen />}
      </form>
    </section>
  );
}

export default ServiceEnquiry;
